/* BIBNEST — one-click cart upsell.
   Adds a variant to the cart and re-renders the cart drawer using
   Dawn's own CartDrawer.renderContents(), so the free-shipping bar,
   totals, line items and this upsell list all refresh in place. */
(function () {
  const ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsToRender(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map((s) => s.id);
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  // Announce status to screen readers via the cart drawer's live region.
  // renderContents() replaces that node, so re-query and write on the next
  // frame to ensure the change is observed and read out.
  function announce(message) {
    requestAnimationFrame(function () {
      const region = document.getElementById('CartDrawer-LiveRegionText');
      if (region) region.textContent = message;
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.bn-upsell__add');
    if (!button) return;

    event.preventDefault();
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.getAttribute('aria-busy') === 'true') return;

    const cart = getCartDrawer();
    const originalLabel = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';

    const body = {
      id: Number(variantId),
      quantity: 1,
      sections: sectionsToRender(cart).join(','),
      sections_url: window.location.pathname,
    };

    fetch(`${ADD_URL}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          button.textContent = 'Unavailable';
          announce('This item is unavailable.');
          setTimeout(() => {
            button.textContent = originalLabel;
            button.removeAttribute('aria-busy');
          }, 1600);
          return;
        }

        const addedTitle = response.product_title || response.title;
        announce(addedTitle ? addedTitle + ' added to your cart.' : 'Item added to your cart.');

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'bn-cart-upsell',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          // renderContents reads parsedState.sections — the AJAX add
          // response already includes a `sections` map when requested.
          cart.renderContents(response);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(() => {
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
      });
  });
})();
